import { useTheme } from '@repo/theme';
import { AITag } from 'component/aitag';
import { Pad } from 'component/basics';
import { CommunityGuidelinesModal } from 'component/modal/moderation/community-guidelines';
import { RichText } from 'component/richtext';
import React, { useState } from 'react';
import { View } from 'react-native';
import type { TLabel } from 'util/stdtypes';
import { t } from 'util/stdtypes';

export function ModerationInfoBanner({
    Tag = <AITag />,
    description = t(
        'moderation.info_ai_moderation_banner_text',
        'To maintain a welcoming and respectful environment, this space uses AI to help moderate comments. AI may flag your post for your additional review if it does not follow the [Community Guidelines]($onPress)',
    ),
}: {
    Tag?: React.ReactNode;
    description?: TLabel;
} = {}) {
    const { colors } = useTheme();
    const [showCommunityGuidelines, setShowCommunityGuidelines] = useState(false);

    return (
        <View
            style={{ backgroundColor: colors.colorSurfaceBannerInfo, paddingHorizontal: 20, paddingVertical: 16, borderRadius: 8 }}
            testID='moderation-info-banner'
        >
            {Tag}
            <Pad size={16} />
            <RichText
                callbacks={{ onPress: () => setShowCommunityGuidelines(true) }}
                color={colors.colorTextPrimary}
                label={description}
                suffixText='.'
            />
            {showCommunityGuidelines && <CommunityGuidelinesModal onClose={() => setShowCommunityGuidelines(false)} />}
        </View>
    );
}
